<template>
  <v-flex data-qa="creditcard-flex-ax3teh">
    <Loader v-show="loaderEnabled" />
    <v-layout wrap class="ml-2 pt-0" data-qa="creditcard-layout-gmhk9m">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="creditcard-flex-epiqhq">
        <v-container data-qa="creditcard-container-0waed">
          <v-flex xs12 sm12 md12 lg12 xl12 class="px-2" data-qa="creditcard-flex-lw2q1c">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="creditcard-flex-spdhhj">
              <v-row no-gutters class="pb-2" data-qa="creditcard-row-50v1tt">
                <inline-svg
                  class="mt-2"
                  :src="getNavigationIcon()"
                  width="50"
                  height="50"
                  aria-label="Navigation Icon"
                ></inline-svg>
                <font class="display-1 font-weight-thin white--text pt-4 pl-2">
                  {{ $t("common.creditLabel") }} ({{
                    creditCard.accounts.length
                  }})</font
                >
              </v-row>
            </v-flex>
            <v-row class="px-2 pl-6" data-qa="creditcard-row-oe6xuv">
              <v-layout v-if="enableOpenCreditCardOption" class="py-2" data-qa="creditcard-layout-dzwrja">
                <v-flex sm12 xs12 md12 lg12 xl12 class="text-right" data-qa="creditcard-flex-5wec5d">
                  <v-btn
                    @click="goToOffer()"
                    color="white"
                    class="text-none py-2 px-4"
                    outlined
                     data-qa="creditcard-btn-qkhxoq">{{ $t("common.applyNewCardLabel") }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="creditcard-flex-mf2ym">
      <CardLayout :config="creditCard" />
    </v-flex>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import CardLayout from '@/views/home/HomeCards.vue'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'Credit',
  components: {
    Loader,
    CardLayout
  },
  data () {
    return {
      accountType: '',
      loaderEnabled: false,
      creditCard: {
        title: this.$t('common.creditTypeLabel'),
        cardLabels: false,
        openNewACCard: false,
        accounts: [],
        enableShowMore: false
      },
      accDetails: {
        myBalance: 0,
        currency: '',
        series: []
      },
      baseCurrency:
        this.$appSettings.defaultConfigurations.currencyFormat.currency,
      enableOpenCreditCardOption:
        this.$appSettings.defaultConfigurations.enableOpenNewAccountOption
      // TODO isMultiCurrency: false
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  created () {
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.creditCard.enableShowMore = true
    } else this.creditCard.enableShowMore = false
    // const exclusionList = this.$appSettings.uiFieldsDisplayConfigurations
    //   .tableColumns.accountListTables.exclusionList
    event.$on('set_myAccounts', () => {
      // this.fetchAccounts()
      this.getListOfAccounts()
      this.loaderEnabled = false
    })
    if (this.ifMyAccountsAvailable()) {
      // this.fetchAccounts()
      this.getListOfAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Savings_1')
    },
    goToOffer () {
      this.$router.push({
        name: 'ApplyCreditCard'
      })
    },
    getListOfAccounts () {
      this.loaderEnabled = true
      const data = store.getters['userStore/userData'].myAccounts
      if (data) {
        this.creditCard.accounts = data.creditCards
          ? data.creditCards.accountList
          : []
        if (this.creditCard.accounts.length) {
          this.creditCard.accounts = _.filter(
            this.creditCard.accounts,
            (account) => {
              return !this.$appSettings.uiFieldsDisplayConfigurations.creditCardsListing.exclusionList.includes(
                account.cardStatus
              )
            }
          )
        }
        for (const i in data) {
          if (data[i].accountList[0]) {
            this.accDetails.currency = data[i].accountList[0].currency
          }
          switch (data[i].label) {
            case 'creditCard':
              this.accDetails.series.push(data[i].totalSavingBalance)
              this.accDetails.myBalance += data[i].totalSavingBalance
              break
            default:
              break
          }
        }
      }
      this.loaderEnabled = false
    },
    fetchAccounts () {
      this.loaderEnabled = true
      const accounts = store.getters['userStore/userData'].myAccounts
      const creditCards = accounts.creditCard
        ? accounts.creditCard.accountList
        : []
      if (creditCards && creditCards.length) {
        this.creditCard.accounts = []
        const excludeAccountStatus = ['BLOCKED', 'STOPPED']
        for (const i in creditCards) {
          if (excludeAccountStatus.includes(creditCards[i].accountStatus)) {
            creditCards[i].balance = this.$t('myAccounts.notAvailableLabel')
          } else {
            if (!isNaN(creditCards[i].balance)) {
              creditCards[i].balance = this.getBalInfo(creditCards[i].balance)
            } else {
              if (
                !creditCards[i].balance &&
                creditCards[i].accountStatus === 'ACTIVATED'
              ) {
                creditCards[i].balance = this.$t(
                  'myAccounts.balanceInquiryRestricted'
                )
              }
            }
          }
          this.creditCard.accounts.push({
            ...creditCards[i],
            status: this.$t(`systemEnums.casa.${creditCards[i].accountStatus}`),
            accountNumber: creditCards[i].accountId
          })
        }
        this.loaderEnabled = false
      } else {
        this.loaderEnabled = false
      }
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].myAccounts
    },
    getBalInfo (bal) {
      if (bal !== undefined && bal.toString().trim().length > 0) {
        if (isNaN(bal)) {
          return bal
        } else {
          return this.$formatter.currency.format(bal)
        }
      } else {
        return this.$t('myAccounts.notAvailableLabel')
      }
    }
  }
}
</script>
